import { useCallback, useState } from "react";
import { acceptArtistInvite, ArtistRosterResponse } from "@/api/client";
import { useAuthStore } from "@/stores/auth";
import { AcceptInviteFlow } from "@/components/AcceptInviteFlow";

export function AcceptArtistInvitePage() {
  const initialize = useAuthStore((s) => s.initialize);
  const [merged, setMerged] = useState(false);

  const handleError = useCallback(async () => {
    await initialize();
    const refreshedUser = useAuthStore.getState().user;
    return !!refreshedUser?.has_artist_profile;
  }, [initialize]);

  const handleSuccess = useCallback((data: unknown) => {
    const resp = data as ArtistRosterResponse;
    if (resp?.profiles_merged) setMerged(true);
  }, []);

  return (
    <AcceptInviteFlow
      returnPath="/accept-artist-invite"
      title="Artist Invite"
      subtitle="Sign in or create an account to claim your artist profile."
      acceptFn={acceptArtistInvite}
      onSuccess={handleSuccess}
      onError={handleError}
      successMessage={
        merged
          ? "Your profiles have been consolidated. All your bookings are now in one place."
          : "Your artist profile has been linked."
      }
      successLink="/my-schedule"
      successLabel="View My Schedule"
    />
  );
}
